export default {
  HOME: {
    pageName: 'home',
    pageTitle: 'PUSH | Previously EPNS'
  },
  TOS: {
    pageName: 'tos',
    pageTitle: 'PUSH | Terms Of Service'
  },
  PRIVACY: {
    pageName: 'privacy',
    pageTitle: 'PUSH | Privacy'
  },
  FAQS: {
    pageName: 'faqs',
    pageTitle: 'PUSH | FAQs'
  },
  FRENS: {
    pageName: 'frens',
    pageTitle: 'PUSH | FrensOfPush'
  },
  SPACES: {
    pageName: 'spaces',
    pageTitle: 'PUSH | spaces'
  },
  CHEAT: {
    pageName: 'cheatsheet',
    pageTitle: 'PUSH | cheatsheet'
  },
  BRB: {
    pageName: 'brb',
    pageTitle: 'PUSH | brb'
  }
};